import React, { useCallback } from 'react';

import { useEditorContext } from 'src/store/editor';
import { LinkStrongIcon } from 'src/monet/icons';
import { useSharePanelStore } from 'src/common/store/share.store';

export const EditorHeaderShareButton = () => {
  const journey = useEditorContext((state) => state.journey);
  const onJourneyShareOpen = useSharePanelStore((state) => state.onJourneyShareOpen);

  const openShareSlideover = useCallback(() => {
    onJourneyShareOpen(journey);
  }, [journey, onJourneyShareOpen]);

  return (
    <button className='flex items-center space-x-xs has-hover py-[9px] px-md pitch-onboarding-share' onClick={openShareSlideover}>
      <LinkStrongIcon />
      <span className='text-bedrock-p-strong'>Share</span>
    </button>
  );
};
